module.exports = __webpack_public_path__ + "img/ennetix-xtend-alert-summary-table.6bd8f29c.png";